import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, SpinnerGap, XCircle } from "@phosphor-icons/react";
import API from "../api";
import GlobalNav from "../components/GlobalNav";
import { useAuth } from "../auth/AuthContext";

export default function BillingSuccessPage() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await API.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setCredits(data.user?.credits ?? null);
          await refresh();
          return;
        }
        if (data.status === "expired" || data.status === "complete") {
          setStatus(data.payment_status === "paid" ? "paid" : "error");
          return;
        }
      } catch {}
      if (attempts < 8) setTimeout(poll, 1500);
      else setStatus("timeout");
    };
    poll();
  }, [refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-white relative" style={{ background: "#0a0a0a" }} data-testid="billing-success">
      <div className="absolute top-5 left-6"><GlobalNav /></div>
      <div className="rounded-2xl p-10 max-w-md text-center" style={{ background: "#0c0c0c", border: "1.5px solid #1f1f1f" }}>
        {status === "checking" && (
          <>
            <SpinnerGap size={48} weight="bold" className="animate-spin mx-auto text-white/70" />
            <h1 className="font-display font-black text-2xl mt-4">Confirming payment…</h1>
            <p className="text-sm text-white/40 mt-2">Hang tight, this only takes a second.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={56} weight="fill" className="mx-auto text-emerald-400" />
            <h1 className="font-display font-black text-2xl mt-4">Payment complete</h1>
            <p className="text-sm text-white/60 mt-2">Your credits have been added to the account.</p>
            {credits !== null && (
              <div className="text-3xl font-extrabold text-emerald-300 mt-3" data-testid="billing-credits-now">{credits}</div>
            )}
            <button onClick={() => nav("/")} className="mt-6 px-6 py-2.5 rounded-full font-bold" style={{ background: "linear-gradient(180deg,#fff,#d4d4d4)", color: "#000" }} data-testid="back-to-app">
              Back to generator
            </button>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <XCircle size={48} weight="fill" className="mx-auto text-red-400" />
            <h1 className="font-display font-black text-2xl mt-4">Something went off-grid</h1>
            <p className="text-sm text-white/50 mt-2">If money was charged, your credits will be applied automatically. Otherwise try again.</p>
            <button onClick={() => nav("/")} className="mt-6 px-6 py-2.5 rounded-full font-bold" style={{ background: "linear-gradient(180deg,#fff,#d4d4d4)", color: "#000" }}>
              Back to generator
            </button>
          </>
        )}
      </div>
    </div>
  );
}
